import React from "react";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Badge, Button } from 'reactstrap';
import { userApi } from "../../reducers/userSlice";
import { useDispatch, useSelector } from "react-redux";

const UserListItem = ({user}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const identity = useSelector( (state) => state.identityReducer.identity);

    const getRoleColor = (role) => {
        let color = 'default';
        switch(role.label) {
            case 'SUPERADMIN': color = 'danger'; break;
            case 'ADMIN': color = 'warning'; break;
            case 'MEMBER': color = 'success'; break;
            default:
                color = 'default';
                break;
        }

        return color;
    }

    const showConfirm = (user) => {
        confirmAlert({
        //   title: 'Confirm to submit',
          message: "Are you sure to "+(user.locked ? 'ENABLE' : 'DISABLE')+" "+user.email+" ?",
          buttons: [
            {
              label: 'Yes',
                onClick: () => { 
                    dispatch( userApi.manageUserLock(user) );
                }
            },
            {
                label: 'No',
                onClick: () => {}
            }
          ]
        });
      };

    return (
        <tr>
            <td> 
                {
                    user.role !== undefined 
                        ? <Badge color={getRoleColor(user.role)} className='text-truncate' style={{width: '65px'}}> {user.role.label} </Badge>
                        : <>-</>
                }
            </td>
            <td>{user.first_name !== null ? user.first_name : "-"}</td>
            <td>{user.last_name !== null ? user.last_name : "-"}</td>
            <td>{user.email}</td>
            <td>
                <Button onClick={() => { navigate("/user/"+user.id) }} className="btn btn-primary " > <i className="fas fa-pencil-alt" /> </Button>
                &nbsp;
                {
                    (user.locked)
                    ? <Button onClick={() => { showConfirm(user) }} className="btn btn-success " > <i className="fas fa-unlock" /> </Button>
                    : <Button onClick={() => { showConfirm(user) }} className="btn btn-danger " disabled={ user.id === identity.user_id }> <i className="fas fa-lock" /> </Button>
                }
            </td>
        </tr>
    )
}

export default UserListItem;

